import { DocumentStatus } from '@alucio/aws-beacon-amplify/src/models';

export const getDocumentPageLink = (origin: string, documentId: string, pageNumber: number = 1): string => {
  return `${origin}/library/${documentId}/${pageNumber}/`;
};

export const getLinkableDocumentVersion = <T>(
  latestPublishedVersion: T | undefined,
  latestVersion: T | undefined,
  isPublisher: boolean,
): T | undefined => {
  return latestPublishedVersion || (isPublisher ? latestVersion : undefined);
};

export const canCopyDocumentLink = (status: string | undefined, isPublisher: boolean): boolean => {
  return status === DocumentStatus.PUBLISHED ||
    (isPublisher && status === DocumentStatus.NOT_PUBLISHED);
};

export const shouldOpenPublisherMode = (status: string | undefined, isPublisher: boolean): boolean =>
  isPublisher && status === DocumentStatus.NOT_PUBLISHED;
